import React from 'react';

/**
 * Pixel-perfect Google Docs inspired SVG icons for image controls
 */

// Image 2 & 3: Wrap text dropdown icon
export const WrapTextDropdownIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    {/* Top line */}
    <rect x="2" y="3" width="16" height="2" rx="0.5" />
    {/* Middle box representing image */}
    <rect x="2" y="7.5" width="6.5" height="5" rx="0.5" />
    {/* Middle text lines beside box */}
    <rect x="10.5" y="8" width="7.5" height="1.8" rx="0.5" />
    <rect x="10.5" y="11" width="5.5" height="1.8" rx="0.5" />
    {/* Bottom line */}
    <rect x="2" y="15" width="16" height="2" rx="0.5" />
  </svg>
);

// Image 3: In line icon
export const InlineWrapIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    {/* Top line */}
    <rect x="2" y="3" width="16" height="2" rx="0.5" />
    {/* Image box on inline baseline */}
    <rect x="2" y="7.5" width="6" height="5" rx="0.5" />
    <rect x="10" y="9" width="8" height="2" rx="0.5" />
    {/* Bottom line */}
    <rect x="2" y="15" width="16" height="2" rx="0.5" />
  </svg>
);

// Image 3: Wrap text icon
export const WrapTextIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    <rect x="2" y="2.5" width="16" height="2" rx="0.5" />
    <rect x="2" y="6.5" width="6.5" height="7" rx="0.5" />
    <rect x="10.5" y="6.5" width="7.5" height="1.8" rx="0.5" />
    <rect x="10.5" y="9.5" width="7.5" height="1.8" rx="0.5" />
    <rect x="10.5" y="12.5" width="5" height="1.8" rx="0.5" />
    <rect x="2" y="15.5" width="16" height="2" rx="0.5" />
  </svg>
);

// Image 3: Break text icon
export const BreakTextIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    <rect x="2" y="3" width="16" height="2" rx="0.5" />
    <rect x="2" y="7.5" width="6.5" height="5" rx="0.5" />
    <rect x="2" y="15" width="16" height="2" rx="0.5" />
  </svg>
);

// Image 3: Behind text icon
export const BehindTextIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    <rect x="4" y="5" width="12" height="10" rx="0.5" fillOpacity="0.4" stroke="currentColor" strokeWidth="1.2" strokeDasharray="1.5 1" />
    <rect x="2" y="3.5" width="16" height="1.8" rx="0.5" />
    <rect x="2" y="7.5" width="16" height="1.8" rx="0.5" />
    <rect x="2" y="11" width="16" height="1.8" rx="0.5" />
    <rect x="2" y="14.5" width="16" height="1.8" rx="0.5" />
  </svg>
);

// Image 3: In front of text icon
export const InFrontTextIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    <rect x="2" y="3.5" width="16" height="1.8" rx="0.5" />
    <rect x="2" y="7.5" width="2" height="1.8" rx="0.5" />
    <rect x="16" y="7.5" width="2" height="1.8" rx="0.5" />
    <rect x="2" y="11" width="2" height="1.8" rx="0.5" />
    <rect x="16" y="11" width="2" height="1.8" rx="0.5" />
    <rect x="2" y="14.5" width="16" height="1.8" rx="0.5" />
    <rect x="5" y="5.5" width="10" height="9" rx="0.5" />
  </svg>
);

// Image 4: Image options paint roller icon
export const ImageOptionsRollerIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Roller head */}
    <rect x="4" y="3" width="16" height="8" rx="2" fill="currentColor" fillOpacity="0.1" />
    <line x1="8" y1="3" x2="8" y2="7" />
    {/* Roller arm */}
    <path d="M20 7v3a2 2 0 0 1-2 2H12v3" />
    {/* Handle */}
    <rect x="10.5" y="15" width="3" height="6" rx="1" fill="currentColor" />
  </svg>
);

// Checkmark icon for Image 3
export const CheckmarkIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <polyline points="4 10.5 8 14.5 16 5.5" />
  </svg>
);

// Chevron down arrow for dropdown
export const ChevronDownIcon = ({ className = 'w-3 h-3', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronRightIcon = ({ className = 'w-3 h-3', ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

// Google Docs toolbar down arrow (solid dark triangle)
export const GoogleDocsCaretDown = ({ className = 'w-2.5 h-2.5', ...props }) => (
  <svg
    viewBox="0 0 10 6"
    fill="currentColor"
    className={className}
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    {...props}
  >
    <polygon points="0,0 10,0 5,6" />
  </svg>
);

// Google Docs menu right arrow (solid triangle, small and delicate)
export const GoogleDocsArrowRight = ({ className = '', ...props }) => (
  <svg
    viewBox="0 0 6 8"
    fill="currentColor"
    className={className}
    width="5"
    height="7"
    style={{ display: 'inline-block', verticalAlign: 'middle', width: '5px', height: '7px', flexShrink: 0 }}
    {...props}
  >
    <polygon points="1,1 5,4 1,7" />
  </svg>
);

// Google Docs "A+" More Fonts Icon
export const MoreFontsIcon = ({ className = 'w-4 h-4', ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    {...props}
  >
    <path d="M2.5 19h2.2l1.9-5h6.8l1.9 5h2.2L11 3h-2L2.5 19zm4.7-6.8L9.9 5.8h.2l2.7 6.4H7.2zM20 7V4h-2v3h-3v2h3v3h2V9h3V7h-3z" />
  </svg>
);

